import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { NewReleaseService } from '../new-release/new-release.service';
import { NewVersionService } from './new-version.service';
import { MainService } from '../main.service';

import { Message } from 'primeng/primeng';


@Component({
  selector: 'app-new-version',
  templateUrl: './new-version.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../style.scss', './new-version.component.css']
})
export class NewVersionComponent implements OnInit {

  versionForm: FormGroup;

  versionOptions: {};
  componentOptions: {};
  projectOptions: {};
  newVersionOptions: {};
  mappingOptions: {};
  activityOptions: {};
  showLastComp: boolean = false;
  lastVersion: any;
  newVersionNumber: any;
  newPrefix: any;
  newMajor: any;
  newMinor: any;
  newRelease: any;
  newPatch: any;
  newVersion: any;
  componentList: any;
  projectList: any;
  isEnabled: boolean = false;
  responce: any;
  versionProjects: any[] = [];
  activityResponce: any;

  msgs: Message[];

  userEmail = localStorage.getItem('userEmail');

  constructor(
    private fb: FormBuilder,
    private newReleaseService: NewReleaseService,
    private mainService: MainService,
    private newVersionService: NewVersionService,
    public dialogRef: MatDialogRef<NewVersionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  async createVersion() {

    if (this.versionForm.get('releaseType').value != '') {

      this.msgs = [];

      this.versionProjects.forEach(async (item) => {
        this.newVersionOptions = {
          version: this.newVersion,
          projectID: item.id
          // session: localStorage.getItem('PMSession') // sending PM user session
        };

        await this.newVersionService.sendVersionData(this.newVersionOptions).then(res => {
          this.responce = res;

          if (JSON.stringify(this.responce.errorMessages) === JSON.stringify([])) {
            this.msgs.push({ severity: 'warn', summary: this.responce.errors.name + "(" + item.name + " )" });
          } else if (this.responce.errors) {
            this.msgs.push({ severity: 'warn', summary: this.responce.errorMessages[0] + "(" + item.name + " )" });
            setTimeout(() => {
              console.log("No Permission");
            },
              5000);
          } else if (this.responce.name.includes("Syntax")) {
            this.msgs.push({ severity: 'warn', summary: 'JIRA Session Expired.. Please login again.' });
          } else {
            this.msgs.push({ severity: 'success', summary: this.responce.name + " created in " + item.name });

            this.activityOptions = {
              user: this.userEmail,
              action: this.newVersion + " - Created",
              file: "--"
            };

            this.newVersionService.sendActivity(this.activityOptions).then(res => {
              this.activityResponce = res;
            });

            setTimeout(() => {
              this.onCancel();
            },
              3000);

          }

        });
      })

    }
    else {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Version information not selected!' });
    }

  }

  onCancel(): void {
    this.dialogRef.close();
  }

  getProjects() {
    this.projectOptions = {
      user: this.userEmail
    };

    this.mainService.getProjectList(this.projectOptions).then(projects => {
      this.projectList = projects;
    });

  }


  getProjectMapping(project) {

    this.mappingOptions = {
      project: project.id
    };

    this.newVersionService.getSupportProject(this.mappingOptions).then(projects => {
      if (projects) {
        this.versionProjects.push({ id: projects[0].id, name: projects[0].name });
      }
    });

  }



  getComponents() {

    this.mainService.getComponents(this.componentOptions).then(components => {
      this.componentList = components;
    });

  }

  getLastVersion() {

    this.newVersionService.getLastVersion(this.versionOptions).then(lastVer => {

      if (JSON.stringify(lastVer) == '{}') {
        this.showLastComp = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'There\'s no previous versions in jira' });
        this.newPrefix = undefined;
        this.isEnabled = false;

      } else {
        this.lastVersion = lastVer[0].version;

        if (this.lastVersion.includes("-")) {
          this.lastVersion = this.lastVersion.replace("-", "_");
        }

        this.newVersionNumber = this.lastVersion.split("_");

        this.newVersionNumber = this.newVersionNumber[this.newVersionNumber.length - 1];

        setTimeout(() => {
          this.newPrefix = this.lastVersion.replace(this.newVersionNumber, "");
        },
          500);

        this.showLastComp = true;

        this.isEnabled = true;

      }

    });

    // create PM session when new version model is opened
    // this.mainService.PMLogin().then(PMlogin => {
    //   localStorage.setItem('PMSession', JSON.stringify(PMlogin.session.value));
    // });

  }

  ngOnInit() {

    this.getProjects();

    this.versionForm = this.fb.group({
      project: ['', Validators.required],
      component: ['', Validators.required],
      releaseType: [''],
    });

    var project = { id: '', name: '' };

    this.versionForm.get('project').valueChanges.subscribe(proj => {
      if (proj != undefined) {
        this.componentOptions = {
          id: proj.id,
          list: '',
          user: this.userEmail
        };

        this.lastVersion = undefined;
        this.newVersion = undefined;
        project = { id: proj.id, name: proj.name };
        this.versionProjects.push(project);
        this.getComponents();

        this.getProjectMapping(project);
      }

    })

    this.versionForm.get('component').valueChanges.subscribe(comp => {
      if (comp != undefined) {

        this.versionOptions = {
          project: project.id,
          component: comp.component
        };

        this.newVersion = undefined;
        this.getLastVersion();

      }

    })

    this.versionForm.get('releaseType').valueChanges.subscribe(comp => {
      var splitNumber = this.newVersionNumber.split(".");
      this.newMajor = parseInt(splitNumber[0]);
      this.newMinor = (+"---" + '000' + parseInt(splitNumber[1])).slice(-3);;
      this.newRelease = (+"---" + '00' + parseInt(splitNumber[2])).slice(-2);
      this.newPatch = parseInt(splitNumber[3]);

      if (this.versionForm.get('releaseType').value.includes("Major")) {
        this.newMajor = parseInt(splitNumber[0]) + 1;
        this.newMinor = (+"---" + '000' + 0).slice(-3);;
        this.newRelease = (+"---" + '00' + 0).slice(-2);
        this.newPatch = 0;
        if (isNaN(this.newMajor)) {
          this.newVersion = "Previous Version Format Invalid"
        } else {
          this.newVersion = this.newPrefix + this.newMajor + "." + this.newMinor + "." + this.newRelease + "." + this.newPatch;
        }
      }

      else if (this.versionForm.get('releaseType').value.includes("Minor")) {
        this.newMinor = parseInt(splitNumber[1]) + 1;
        this.newMinor = (+"---" + '000' + this.newMinor).slice(-3);
        this.newRelease = (+"---" + '00' + 0).slice(-2);
        this.newPatch = 0;
        if (isNaN(this.newMajor) || isNaN(this.newMinor)) {
          this.newVersion = "Previous Version Format Invalid"
        } else {
          this.newVersion = this.newPrefix + this.newMajor + "." + this.newMinor + "." + this.newRelease + "." + this.newPatch;
        }
      }

      else if (this.versionForm.get('releaseType').value.includes("Release")) {
        this.newRelease = parseInt(splitNumber[2]) + 1;
        this.newRelease = (+"---" + '00' + this.newRelease).slice(-2);
        this.newPatch = 0;
        if (isNaN(this.newMajor) || isNaN(this.newMinor) || isNaN(this.newRelease)) {
          this.newVersion = "Previous Version Format Invalid"
        } else {
          this.newVersion = this.newPrefix + this.newMajor + "." + this.newMinor + "." + this.newRelease + "." + this.newPatch;
        }
      }

      else if (this.versionForm.get('releaseType').value.includes("Patch")) {
        this.newPatch = parseInt(splitNumber[3]) + 1;
        if (isNaN(this.newPatch)) {
          this.newPatch = 1;
        }

        if (isNaN(this.newMajor) || isNaN(this.newMinor) || isNaN(this.newRelease)) {
          this.newVersion = "Previous Version Format Invalid"
        } else {
          this.newVersion = this.newPrefix + this.newMajor + "." + this.newMinor + "." + this.newRelease + "." + this.newPatch;
        }

      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Version information not selected!' });
      }
    })
  }
}
